// The 14 household segments under the Family-Based Household Segmentation
// Framework. Detail content for each is wired up later — for now every
// segment renders as "coming soon".
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import EngineeringIcon from '@mui/icons-material/Engineering';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import WomanIcon from '@mui/icons-material/Woman';
import SchoolIcon from '@mui/icons-material/School';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ElderlyIcon from '@mui/icons-material/Elderly';
import PetsIcon from '@mui/icons-material/Pets';
import LuggageIcon from '@mui/icons-material/Luggage';
import ConstructionIcon from '@mui/icons-material/Construction';
import DevicesIcon from '@mui/icons-material/Devices';
import PolicyIcon from '@mui/icons-material/Policy';
import RestaurantIcon from '@mui/icons-material/Restaurant';

export const familySegments = [
  { id: 'poor-vulnerable', title: 'Poor & Vulnerable Families', icon: VolunteerActivismIcon, accent: 'var(--cat-subhadra)' },
  { id: 'farmer', title: 'Farmer Families', icon: AgricultureIcon, accent: 'var(--cat-skill-livelihood)' },
  { id: 'landless-labour', title: 'Landless Labour Families', icon: EngineeringIcon, accent: 'var(--cat-skill-livelihood)' },
  { id: 'youth', title: 'Youth Families', icon: EmojiPeopleIcon, accent: 'var(--cat-gender)' },
  { id: 'women-led-development', title: 'Women-led Development Families', icon: WomanIcon, accent: 'var(--cat-women-child)' },
  { id: 'school-going-children', title: 'Families with School-going Children', icon: SchoolIcon, accent: 'var(--cat-education)' },
  { id: 'health-priority', title: 'Health Priority Families', icon: LocalHospitalIcon, accent: 'var(--cat-health)' },
  { id: 'senior-citizen', title: 'Senior Citizen Families', icon: ElderlyIcon, accent: 'var(--cat-household)' },
  { id: 'livestock', title: 'Livestock Families', icon: PetsIcon, accent: 'var(--cat-skill-livelihood)' },
  { id: 'migrant', title: 'Migrant Families', icon: LuggageIcon, accent: 'var(--cat-household)' },
  { id: 'infrastructure-gap', title: 'Infrastructure Gap Families', icon: ConstructionIcon, accent: 'var(--cat-housing)' },
  { id: 'digital', title: 'Digital Families', icon: DevicesIcon, accent: 'var(--primary)' },
  { id: 'welfare-gap', title: 'Welfare Gap Families', icon: PolicyIcon, accent: 'var(--cat-subhadra)' },
  { id: 'nutrition-priority', title: 'Nutrition Priority Families', icon: RestaurantIcon, accent: 'var(--cat-health)' },
];

export const getFamilySegmentById = (id) => familySegments.find((s) => s.id === id) || null;

export default familySegments;
